const initComments = () => {
  const stars = document.querySelectorAll(".star-rating .star");
  const ratingInput = document.querySelector("#rating");

  stars.forEach((star) => {
    star.addEventListener("mouseover", function () {
      resetStars();
      highlightStars(this.dataset.value);
    });

    star.addEventListener("mouseout", function () {
      resetStars();
      if (ratingInput.value) {
        highlightStars(ratingInput.value);
      }
    });

    star.addEventListener("click", function () {
      ratingInput.value = this.dataset.value;
      resetStars();
      highlightStars(this.dataset.value);
    });
  });

  function highlightStars(count) {
    stars.forEach((star) => {
      if (star.dataset.value <= count) {
        star.classList.add("selected");
      }
    });
  }

  function resetStars() {
    stars.forEach((star) => star.classList.remove("selected"));
  }
}

export {initComments}